import { Cycle } from '@statsbomb/parachute-types';
import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { atomWithSuspenseQuery } from 'jotai-tanstack-query';
import { fetchClientAtom } from '@/atoms/queries/client';
import { competitionIdsToFilterByAtom } from '../filters/highLevel/competitions';
import { seasonIdsToFilterByAtom } from '../filters/highLevel/seasons';

export const rawCyclesAtom = atomWithSuspenseQuery(get => {
  const { fetch } = get(fetchClientAtom);
  return {
    queryKey: ['cycles'],
    queryFn: async () => (await fetch(`/cycles`)) as Promise<Cycle[]>,
  };
});

const selectedCycleAtom = atom(async get => {
  const cycles = (await get(rawCyclesAtom)).data;
  const competitionIdsToFilterBy = get(competitionIdsToFilterByAtom);
  const seasonIdsToFilterBy = get(seasonIdsToFilterByAtom);

  return cycles.find(
    cycle => cycle.competition_id === competitionIdsToFilterBy[0] && cycle.season_id === seasonIdsToFilterBy[0],
  );
});

export const unwrappedSelectedCycleAtom = unwrap(selectedCycleAtom, prev => prev);
